import { Check, Circle } from '@tamagui/lucide-icons-2'
import { SizableText, View, XStack } from 'tamagui'

// Line height of SizableText size="$3" on web (14px → 21, per the Tamagui v5 font scale).
// The check is centered within ONE line so it lines up with the first line of the label —
// when a label wraps to two lines, alignItems="center" would otherwise float the check in
// the vertical middle of the whole block, leaving it aligned with neither line.
const LINE_HEIGHT = 21

export const CheckItem = ({ checked, label }: { checked: boolean; label: string }) => (
    <XStack gap="$2" alignItems="flex-start">
        <View height={LINE_HEIGHT} alignItems="center" justifyContent="center">
            {checked ? (
                <View
                    width={16}
                    height={16}
                    borderRadius={999}
                    backgroundColor="$statusOk"
                    alignItems="center"
                    justifyContent="center"
                >
                    <Check size={10} color="white" />
                </View>
            ) : (
                <Circle size={16} color="$colorFaint" />
            )}
        </View>
        <SizableText
            flex={1}
            size="$3"
            lineHeight={LINE_HEIGHT}
            color={checked ? '$color' : '$colorMuted'}
            textDecorationLine={checked ? 'line-through' : 'none'}
        >
            {label}
        </SizableText>
    </XStack>
)
